import React from 'react';

export const PcScroll = React.createContext({ scrollToView: (ele: HTMLElement) => {} });
